import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Container, Tabs, Tab } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useURLHandler } from 'src/utils/hooks';
import { CompanyDetailsTab } from './CompanyDetailsTab';
import { PersonalDetailsTab } from './PersonalDetailsTab';
import { SignInDetailsTab } from './SignInDetailsTab';
import useProfileSettingsPageStyles from './styles';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
export const ProfileSettingsPage = observer(() => {
  const classes = useProfileSettingsPageStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const tabsNames = ['personal-details', 'sign-in-details', 'company-details'];
  const _useURLHandler = _objectSpread({}, useURLHandler('personal-details', tabsNames)),
    handleSelectedTabChange = _useURLHandler.handleSelectedTabChange,
    selectedTab = _useURLHandler.selectedTab;
  const handleChange = (event, newValue) => handleSelectedTabChange(newValue);
  const tabs = [{
    label: t('profile_settings.personal_details'),
    value: 'personal-details'
  }, {
    label: t('profile_settings.sign-in_and_security'),
    value: 'sign-in-details'
  }, {
    label: t('company_details.title'),
    value: 'company-details'
  }];
  const getSelectedTab = () => {
    switch (selectedTab) {
      case 'sign-in-details':
        return /*#__PURE__*/React.createElement(SignInDetailsTab, null);
      case 'company-details':
        return /*#__PURE__*/React.createElement(CompanyDetailsTab, null);
      case 'personal-details':
      default:
        return /*#__PURE__*/React.createElement(PersonalDetailsTab, null);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tabs, {
    "aria-label": "tabs navigation",
    onChange: handleChange,
    position: "sticky",
    type: "navigation",
    value: selectedTab
  }, tabs.map(tab => /*#__PURE__*/React.createElement(Tab, {
    key: tab.value,
    label: tab.label,
    value: tab.value,
    disabled: store.account.updatePasswordAsync.inProgress || store.account.getProfileAsync.inProgress || store.account.getProfileAsync.inProgress || store.account.updateEmailByAccountIdAsync.inProgress || store.account.updateProfileByAccountIdAsync.inProgress || store.account.updatePhoneNumberAsync.inProgress || store.company.getCurrentUserCompanyFromTokenAsync.inProgress || store.address.batchGetAddressesAsync.inProgress || store.company.updateCompanyAsync.inProgress || store.address.updateAddressAsync.inProgress || store.address.addNewAddressAsync.inProgress
  }))), /*#__PURE__*/React.createElement(Box, {
    className: classes.flexGrow
  }, /*#__PURE__*/React.createElement(Container, null, getSelectedTab())));
});